import { render } from "./Catalog.vue?vue&type=template&id=840d0712"
import script from "./Catalog.vue?vue&type=script&lang=js"
export * from "./Catalog.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Catalog.vue?vue&type=style&index=0&id=840d0712&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__